import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem 0;
  background: ${({ theme }) => theme.colors.background};
  min-height: 100vh;

  .page-title {
    display: flex;
    width: 90%;
    justify-content: start;
  }

  .container {
    display: flex;
    justify-content: center;

    width: 85%;
    max-width: 100rem;
  }

  .contentButton {
    width: 85%;
    max-width: 100rem;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 350px) {
    .contentButton {
      justify-content: center;
    }
  }
`;
